import { render, staticRenderFns } from "./AttachmentErrorMessage.vue?vue&type=template&id=c7c5ad56"
import script from "./AttachmentErrorMessage.vue?vue&type=script&lang=js"
export * from "./AttachmentErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports